angular.module('rjmNg.services').factory 'columnErrorService', [
  () ->
    # Pass in an array of error responses and it turns an array of human readable messages
    get : (errors) ->
      response = []
      for error in errors
        response.push @_parse(error)
      return response

    # They key here is the server response. The value is what we're returning to the user.
    # When adding new messages, make sure the regexes don't collide with existing ones
    _getResponseMap : () ->

      responses =
        'field_type must be one of':
          'You must set a proper column type'

        'source_column_id must be a valid column':
          'Your chosen source column is not a valid column'

        'filter_set must be valid':
          'There is a problem with your filters'

        'first local_column_ids must be in this table':
          'The local column you chose is not on this table'

        'Not permitted to modify properties: \'old-data-type\'':
          "You cannot make changes to this column that result in a datatype change. Please create a new column or contact support."

        'janino':
          "This calculation column can't currently be used in a path. File a support request to create this path."

        'Extraneous properties attributes:':
          "We can't change the operation type of this column. Please create a new column or contact support."

        "Cannot read property 'data_type' of undefined":
          "You must select a source column to save this change."

    # Checks through the response map and returns the appropriate message
    _parse : (error) ->
      for response, message of @_getResponseMap()
        if error.name is 'TypeError' and
          error.message? and
            error.message.match response
          return message
        else
          try
            if error.match response then return message

      # Catch to make sure we return something if we can't handle the error message
      # If this is being called, you should write a response for this error in the responseMap
      return error
 ]
